import type { FaireProductEntity } from "../../entity_types/product";

export const p_3fbndntsav: FaireProductEntity = {
  token: "p_3fbndntsav",
  type: "product",
  name: "Instant Hand Sanitizer, Crème Douce, 12 oz",
  brandToken: "b_cf402a0d",
  brandName: "Noodle & Boo, Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/86fbf9eb03202e3fa3b9984ce1f28f0bc75a1c2f107098b4a9f5330a07664572.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b4fdda2c02ceb295e482fa005006f1a6da7d89b15c17bb2ef908fc135a645ab.jpeg",
    "https://cdn.faire.com/fastly/de8cfbf04c5c5ac0ce9938321b43466775549715868251edea3068586e1595ff.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "Keep little hands (and big ones too) clean and cared for with our gentle, plant-based sanitizer:\n•    Helps reduce bacteria on the skin to support good hygiene\n•    Vegetable glycerin leaves hands soft and supple, never dry\n•    Makes hygiene fun while keeping the whole family germ-free and healthy\n•    Recommended for repeated use throughout the day\n•    Please note: this product is restricted to standard shipping per federal law\n\nOur Promise:\n•    Hypoallergenic\n•    Pediatrician-tested & Dermatologist-tested\n•    Cruelty-free and Non-toxic\n•    Made in USA\n•    Free from Parabens, Phthalates, Sulfates, PPGs, and Dyes",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:41.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
